import { URLS, HTTP_METHODS } from 'modules/api/constants';
import handleRequest from 'modules/api/common';
import createRequest from 'modules/api/request';
import { CancelFunctions } from 'components/common/types';
import { CreativeStatus } from 'components/common/types/Creative.types';

export const getResellerMediaOwners = (
  reseller: string,
  cancelFunctions: CancelFunctions,
): Promise<{
  applicationConfiguration: { mediaOwners: string; exclusiveDsps: string; isInternalPublisher: string };
}> => {
  const reqOptions = {
    url: URLS().FETCH_RESELLER_MEDIA_OWNERS(reseller),
    method: HTTP_METHODS.GET,
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_RESELLER_MEDIA_OWNERS');
};

export const getEligibleResellerMediaOwners = (
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<string[]> => {
  const reqOptions = {
    url: URLS().FETCH_ELIGIBLE_RESELLER_MEDIA_OWNERS(marketId),
    method: HTTP_METHODS.GET,
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_ELIGIBLE_RESELLER_MEDIA_OWNERS');
};

export interface ResellerMediaOwnersCreativeStatusResponse {
  publisher: string;
  status: CreativeStatus;
  updateStamp: number;
  automatic?: boolean;
}

export const getResellerMediaOwnersCreativeStatus = (
  marketId: string,
  cancelFunctions: CancelFunctions,
): Promise<ResellerMediaOwnersCreativeStatusResponse[]> => {
  const reqOptions = {
    url: URLS().FETCH_RESELLER_MEDIA_OWNERS_CREATIVE_STATUS(marketId),
    method: HTTP_METHODS.GET,
  };

  return handleRequest(reqOptions, cancelFunctions, 'FETCH_RESELLER_MEDIA_OWNERS_CREATIVE_STATUS');
};

export const downloadPreferredPricingFile = async (
  dynamoDbFileId: string,
  cancelFunctions: CancelFunctions,
): Promise<{ data: Blob; headers: Record<string, string> }> => {
  const { send, cancel } = createRequest({
    url: URLS().DOWNLOAD_PREFERRED_PRICING_FILE(dynamoDbFileId),
    method: HTTP_METHODS.GET,
    responseType: 'blob',
    showLoader: true,
    ignoreNotifyError: true,
  });

  if (cancelFunctions.DOWNLOAD_PREFERRED_PRICING_FILE) {
    cancelFunctions.DOWNLOAD_PREFERRED_PRICING_FILE();
  }
  cancelFunctions.DOWNLOAD_PREFERRED_PRICING_FILE = cancel;

  return send();
};
